import { DatePicker, Select } from './forms';
import type { Choice } from './forms';
import './analysis-controls.css';

/**
 * Старые имена контролов аналитики. С «Основы форм» (F0) это тонкие обёртки
 * над `ui/forms`: вид (`ac-*`) и поведение прежние, логика — одна на все формы.
 * Новый код берёт компоненты из `ui/forms` напрямую.
 */
export type { Choice };

export function ChoiceSelect({ label, value, options, onChange, disabled = false }: { label: string; value: string; options: Choice[]; onChange: (value: string) => void; disabled?: boolean }) {
  return <Select label={label} value={value} options={options} onChange={onChange} isDisabled={disabled} searchable={false} />;
}

export function SearchChoice({ label, value, options, onChange }: { label: string; value: string; options: Choice[]; onChange: (value: string) => void }) {
  return <Select className="ac-search" label={label} value={value} options={options} onChange={onChange} searchable />;
}

export function CalendarDateField({ label, value, onChange, min = '2024-10-01', max = '2026-08-26', optional = false }: { label: string; value: string; onChange: (value: string) => void; min?: string; max?: string; optional?: boolean }) {
  return (
    <DatePicker
      label={label}
      value={value || null}
      minValue={min}
      maxValue={max}
      placeholderValue={min}
      onChange={(next) => {
        if (next) onChange(next);
        else if (optional) onChange('');
      }}
    />
  );
}
